import { createTheme } from '@mui/material/styles';

// Ringostat brand colors
const ringostatGreen = '#00C853';
const accentBlue = '#29B6F6';
const accentOrange = '#FFA726';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: ringostatGreen,
      contrastText: '#fff',
    },
    secondary: {
      main: accentBlue,
    },
    background: {
      default: '#f5f7fa',
      paper: '#fff',
    },
    text: {
      primary: '#222',
      secondary: '#666',
    },
    info: {
      main: accentBlue,
    },
    warning: {
      main: accentOrange,
    },
  },
  typography: {
    fontFamily: '"Open Sans", Roboto, Arial, sans-serif', // Changed to Open Sans
    h4: {
      fontWeight: 700,
    },
    h6: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
        },
      },
    },
  },
});

export default theme;
